<template>
    <path d="M0 10.5H28" />
    <path d="M19 1.5L28 10.5L19 19.5" fill="none" stroke-linecap="square" />
</template>
